<div
	class="profit-history"
	[nbSpinner]="loading"
	nbSpinnerStatus="primary"
	nbSpinnerSize="large"
>
	<h5>{{ 'DASHBOARD_PAGE.PROFIT_HISTORY.PROFIT_REPORT' | translate }}</h5>
	<div class="totals">
		<nb-card>
			<div class="mx-auto p-2">
				{{ 'DASHBOARD_PAGE.PROFIT_HISTORY.TOTAL_EXPENSES' | translate }}
			</div>
			<div class="mx-auto pb-2">
				<b>{{ recordsData.expenseTotal }} {{ currency }}</b>
			</div>
		</nb-card>
		<nb-card>
			<div class="mx-auto p-2">
				{{ 'DASHBOARD_PAGE.PROFIT_HISTORY.TOTAL_INCOME' | translate }}
			</div>
			<div class="mx-auto pb-2">
				<b>{{ recordsData.incomeTotal }} {{ currency }}</b>
			</div>
		</nb-card>
		<nb-card>
			<div class="mx-auto p-2">
				{{ 'DASHBOARD_PAGE.PROFIT_HISTORY.TOTAL_PROFIT' | translate }}
			</div>
			<div class="mx-auto pb-2">
				<b>{{ recordsData.profit }} {{ currency }}</b>
			</div>
		</nb-card>
	</div>
	<ng2-smart-table
		class="table"
		[settings]="smartTableSettings"
		[source]="smartTableSource"
		#profileHistoryTable
	>
	</ng2-smart-table>
</div>
